import { PdBadgeItem } from "./PdBadgeItem.js";
//#region src/pd-badge-order/pd-badge-item.ts
var tag = "pd-badge-item";
if (!customElements.get(tag)) customElements.define(tag, PdBadgeItem);
//#endregion
export { PdBadgeItem };
